<script>
import { v4 as uuidv4 } from "uuid";
import * as categoryService from "../../service/category.service";

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      value: Array.isArray(this.item_value) ? this.item_value : [],
      isModalVisible: false,
      new_item: "",
      options: [],
      leveldisplay: true,
      d_check: this.selectedItem
        ? this.selectedItem[this.item.displayOn]
        : false,
    };
  },
  methods: {
    optionHandle() {
      if (this.item_key === "pharmacy_list") {
        let { pharmacy_type } = this.selectedItem;
        if (pharmacy_type && pharmacy_type === "Predefined list") {
          this.leveldisplay = true;
        } else {
          this.leveldisplay = false;
        }
      }
    },
    toggleModal() {
      this.isModalVisible = !this.isModalVisible;
    },
    addPPG() {
      this.value.push({
        id: uuidv4(),
        attachment: "",
      });
    },
    removeItem(index) {
      this.value.splice(index, 1);
    },
    async getOptions() {
      let filter = {
        where: {
          name: "Documents",
          cmsId: this.$route.params.cmsId,
        },
        include: [
          {
            relation: "pages",
          },
        ],
      };

      filter = encodeURIComponent(JSON.stringify(filter));

      let data = await categoryService.getWithFilter(filter);
      let pages = data.length ? data[0].pages : [];
      this.options = pages;
      let validFileFormats = ["application/pdf"];
      this.options = pages.filter((x) =>
        validFileFormats.includes(x.additionalProp1.fileFormat)
      );
      // this.value = this.options.filter(x => x.url == this.item_value)[0]
    },
  },
  computed: {
    level_two_display() {
      if (this.item_key === "pharmacy_list") {
        return this.leveldisplay && this.display_none_check;
      }
      return this.display_none_check;
    },
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
  },
  watch: {
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        }
      },
      deep: true,
    },
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    selectedItem: {
      handler() {
        // need to remove this code once two level of form rules supportted
        this.optionHandle();
        //
      },
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
    display_none_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
  },
  async mounted() {
    await this.getOptions();
    this.optionHandle();
  },
};
</script>
<template>
  <div class="" :class="{ 'd-none': item.displayOn && !level_two_display }">
    <b-modal
      v-model="isModalVisible"
      style="letter-spacing: 2em"
      id="add-ppg-newsletters"
      centered
      title="Add Item"
      title-class="font-18"
      hide-footer
    >
      <div class="d-flex mb-3">
        <input v-model="new_item" type="text" class="form-control mr-2" />
        <button
          class="btn btn-primary"
          @click="
            addPPG();
            $bvModal.hide('add-ppg-newsletters');
          "
        >
          Add
        </button>
      </div>
    </b-modal>
    <div class="full-width-flex">
      <div class="blue-ray-section"></div>
      <div class="w100">
        <div class="section-label">{{ item.label }}</div>
        <div v-for="(sg, index) in value" :key="sg.id" class="d-flex mb-2">
          <input
            v-model="sg.title"
            type="text"
            class="form-control mb-2 mr-3"
          />
          <a
            class="font-size-14 mb-2 font-weight-medium ml-3 align-self-sm-center"
            role="button"
            style="color: #da3f3f"
            v-on:click="removeItem(index)"
            >Remove</a
          >
        </div>
        <div class="mt-2">
          <a
            class="font-size-14 mb-2 ml-auto align-self-sm-center cursor-pointer"
            @click="addPPG()"
            >+ Add Item</a
          >
        </div>
        <div v-if="submitted && validation.$error" class="invalid-feedback">
          <span v-if="!validation.required">This value is required.</span>
        </div>
        <portal-target :name="item_key"> </portal-target>
      </div>
    </div>
  </div>
</template>
<style>
.section-label {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #333;
  padding-bottom: 20px;
}
.blue-ray-section {
  width: 20px;
  height: auto;
  background: #cad9f6;
  margin-right: 30px;
}
.full-width-flex {
  display: inline-flex;
  width: 100%;
}
.w100 {
  width: 100%;
}
</style>
